import { Component } from '@angular/core';

@Component({
    selector: 'app-acces-interzis',
    templateUrl: './acces-interzis.component.html',
    styleUrls: ['./acces-interzis.component.scss']
})
export class AccesInterzisComponent {

}
